<template>
  <div id="app" :class="appClass">
    <!-- 全屏页面（登录/注册）不显示 Header/Footer -->
    <template v-if="!isFullPage">
      <HeaderComp />
    </template>

    <div class="main-content" :class="{ 'no-responsive': isFormPage }">
      <keep-alive :include="cachedViews">
        <router-view />
      </keep-alive>
    </div>

    <template v-if="!isFullPage">
      <FooterComp />
    </template>

    <!-- 全局未登录提示弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="loginTipVisible"
      width="360px"
      :show-close="false"
      :close-on-click-modal="false"
      append-to-body
      custom-class="login-tip-dialog"
    >
      <div class="login-tip-body">
        <i class="el-icon-warning" />
        <span>您还未登录，请先登录后再进行操作</span>
      </div>
      <span slot="footer">
        <el-button @click="loginTipVisible = false">取消</el-button>
        <el-button type="primary" @click="goLogin">去登录</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import HeaderComp from '@/components/Header.vue'
import FooterComp from '@/components/Footer.vue'

export default {
  name: 'App',
  components: { HeaderComp, FooterComp },
  computed: {
    /** 未登录提示弹窗显示状态 */
    loginTipVisible: {
      get () {
        return this.$store.state.loginTipVisible
      },
      set (val) {
        this.$store.commit('SET_LOGIN_TIP', val)
      }
    },
    /** 是否全屏页面（隐藏 Header/Footer） */
    isFullPage () {
      return !!(this.$route.meta && this.$route.meta.isFullPage)
    },
    /** 是否表单页面（禁用响应式，固定宽度） */
    isFormPage () {
      return !!(this.$route.meta && this.$route.meta.noResponsive)
    },
    appClass () {
      return {
        'full-page': this.isFullPage,
        'form-page': this.isFormPage
      }
    },
    /** 需要缓存的组件名称列表 */
    cachedViews () {
      return ['Xxgk']
    }
  },
  watch: {
    '$route' () {
      // 路由切换时滚动到顶部
      window.scrollTo(0, 0)
    }
  },
  methods: {
    /** 去登录（returnUrl 已在路由守卫中保存） */
    goLogin () {
      this.loginTipVisible = false
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss">
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  /* 顶部固定 Header 占位，PC 头部高 98px */
  padding-top: 98px;
}

/* 窄屏移动端 Header 较矮 */
@media (max-width: 1279px) {
  #app {
    padding-top: 56px;
  }
}

/* 全屏页（登录/注册）隐藏 Header，无需留白 */
#app.full-page {
  padding-top: 0;
}

.main-content {
  flex: 1;
  width: 100%;
}

/* 表单页面固定宽度，不响应式 */
.main-content.no-responsive {
  min-width: 1200px;
}

/* 表单页（固定 1200px）保留横向滚动，不被 #app 裁剪 */
#app.form-page {
  overflow-x: auto;
}

/* 全屏页面（登录注册） */
#app.full-page {
  background: #f5f5f5;
}

/* 未登录提示弹窗 */
.login-tip-body {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  color: #606266;
  line-height: 1.6;

  .el-icon-warning {
    font-size: 22px;
    color: #e6a23c;
    flex-shrink: 0;
  }
}
</style>
